/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonProposalClosedListRequest = {
    status?: Array<'PASSED' | 'REJECTED' | 'FAILED'>;
    type?: Array<string>;
    sortField?: BabylonProposalClosedListRequest.sortField;
    sortDirection?: BabylonProposalClosedListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace BabylonProposalClosedListRequest {

    export enum sortField {
        ID = 'ID',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

